import "./home.css";
import { legacyGraphRedirect } from "./home-redirect.ts";

const redirect = legacyGraphRedirect(window.location.search);
if (redirect) window.location.replace(redirect + window.location.hash);

const video = document.querySelector<HTMLVideoElement>("[data-feed-video]");
const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
function syncMotion() {
  if (!video) return;
  if (reducedMotion.matches) { video.pause(); video.removeAttribute("autoplay"); }
  else void video.play().catch(() => { /* autoplay refused; the poster frame remains */ });
}
syncMotion();
reducedMotion.addEventListener("change", syncMotion);
document.addEventListener("visibilitychange", () => {
  if (!video || reducedMotion.matches) return;
  if (document.hidden) video.pause(); else void video.play().catch(() => {});
});

const seq = document.querySelector<HTMLElement>("[data-hud-seq]");
const screens = [...document.querySelectorAll<HTMLElement>("[data-screen]")];

function activate(screen: HTMLElement) {
  for (const other of screens) other.toggleAttribute("data-active", other === screen);
  if (seq) seq.textContent = `SEQ ${screen.dataset.seq ?? "00"}`;
  document.body.dataset.activeScreen = screen.dataset.screen;
}

// The screen crossing the viewport's centre line is active, however tall it is.
const observer = new IntersectionObserver((entries) => {
  const visible = entries.find((entry) => entry.isIntersecting);
  if (visible) activate(visible.target as HTMLElement);
}, { rootMargin: "-50% 0px -50% 0px", threshold: 0 });
for (const screen of screens) observer.observe(screen);
if (screens[0]) activate(screens[0]);

const form = document.querySelector<HTMLFormElement>("[data-contact-form]");
const submit = document.querySelector<HTMLButtonElement>("[data-submit-contact]");
const submitLabel = document.querySelector<HTMLElement>("[data-submit-label]");
const status = document.querySelector<HTMLElement>("[data-form-status]");

if (form && submit && submitLabel && status) {
  const setStatus = (message: string, state: "idle" | "success" | "error" = "idle") => { status.textContent = message; status.dataset.state = state; };
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    submit.disabled = true; submit.setAttribute("aria-busy", "true");
    submitLabel.textContent = "Sending"; setStatus("Sending…");
    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: { accept: "application/json", "content-type": "application/json" },
        body: JSON.stringify(Object.fromEntries(new FormData(form).entries())),
      });
      const result = await response.json().catch(() => ({})) as { ok?: boolean; error?: string };
      if (!response.ok || !result.ok) throw new Error(result.error || "Your message could not be sent.");
      form.reset();
      setStatus("Message sent. We'll reply to your email.", "success");
      submitLabel.textContent = "Sent";
    } catch (error) {
      setStatus(error instanceof Error ? error.message : "Your message could not be sent. Please try again.", "error");
      submitLabel.textContent = "Try again";
    } finally {
      submit.disabled = false; submit.removeAttribute("aria-busy");
    }
  });
}
